module.exports = __webpack_public_path__ + "static/media/add_white.1fb0fa67.svg";